import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal"
import { useEffect, useMemo } from "react";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import { EntregaObraClienteReportFotoForm, EntregaObraClienteReportFotoSchema } from "../../../schemas/entrega_obra_cliente_verificacao/entregaObraClienteReportFoto";

/**
 * EntregaObraClienteReportFotoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;

  onClose: () => void;
  onSubmit: (form: EntregaObraClienteReportFotoForm) => void;
};

export const EntregaObraClienteReportFotoModal = ({
  open,
  saving,
  loading,

  onClose,
  onSubmit,
}: Props) => {



  const hookForm = useForm<EntregaObraClienteReportFotoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(EntregaObraClienteReportFotoSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  const opcoesRetrabalho = useMemo(() => {
    return [
      {
        id: '1N',
        label: 'NA - Não se aplica',
      },
      {
        id: '1A',
        label: 'A - Aprovado',
      },
      {
        id: '1R',
        label: 'R - Retrabalho',
      },
      {
        id: '1X',
        label: 'X1 - Reprovado 1° inspeção',
      },
      {
        id: '2A',
        label: 'RA - Retrabalho Aprovado',
      },
      {
        id: '2X',
        label: 'X2 - Reprovado 2° inspeção',
      },
    ];
  }, [
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="40rem"
      title='Termos'
      onClose={onClose}
      confirmButtonLabel={"Gerar relatório"}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow" border={false} padding="small">
        <>
          <DefaultFormMultiAutocomplete
            name='retrabalho'
            label='Retrabalho'
            required={false}
            options={opcoesRetrabalho}
            getOptionKey={x => x.id}
            getOptionLabel={x => x.label}
            reactHookForm={hookForm}
          />

        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}